export enum ContractSignType {
  CUSTOMER = 'customer',
  BROKER = 'broker'
}
